<template>
  <el-row :gutter="16">
    <el-col :span="6" v-for="item in cards" :key="item.label">
      <el-card>
        <div>{{ item.label }}</div>
        <h2>{{ item.value }}</h2>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { stats } from '../api/admin';

export default {
  data() {
    return { data: {} };
  },
  computed: {
    cards() {
      return [
        { label: '商户总数', value: this.data.merchant_count || 0 },
        { label: '客服总数', value: this.data.agent_count || 0 },
        { label: '活跃会话', value: this.data.active_conversation_count || 0 },
        { label: '消息总量', value: this.data.message_count || 0 }
      ];
    }
  },
  async created() {
    const { data } = await stats();
    this.data = data.data || {};
  }
};
</script>

